import axios from "@/axios";

export const namespaced = true

const defaultData = {
    orderId: 0,
    fundCitationId: 0,
    name: null,
    abbreviation: null,
    amount: 0,
    Remark: null,
    Completed:false,
    CreateBy: null,
    UpdateBy: null
}

export const state = {
    fundCitations:[],
    fundCitation: Object.assign({}, defaultData),
    fundCitationsErrors: [],
    status: false,
}

export const getters = {
    fundCitations: state => state.fundCitations,
    fundCitation: state => state.fundCitation,
    fundCitationStatus: state => state.status,
    fundCitationsErrors: state => state.fundCitationsErrors,
}

export const mutations = {
    SET_FUND_CITATION: (state, response) => {
        state.fundCitation = Object.assign({}, defaultData, response.data)
    },
    SET_FUND_CITATIONS: (state, response) => {
        state.fundCitations = response.data
    },
    CLEAR_DATA(state) {
        state.fundCitation = Object.assign({}, defaultData)
    },
    SET_STATUS(state, status) {
        state.status = status;
    },
  SET_ERRORS(state, data) {
    state.fundCitationsErrors = data;
  },
  CLEAR_ERRORS(state) {
      state.fundCitationsErrors = [];
  }
}

export const actions = {
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    async getFundCitationStatus({ commit }, id) {
        if (id == 0) {
            commit("SET_STATUS", false)
        } else {
            return await axios.get('/api/fundcitations/order/status/' + id)
                .then(({ data }) => {
                    if(data && data.length === 0) {
                        commit("SET_STATUS", true);
                        commit("CLEAR_ERRORS");
                    } else {
                      commit("SET_STATUS", false);
                        commit("SET_ERRORS", data);
                    }
                })
        }
    },
    async getFundCitations({ commit, state}, orderId) {
        commit("SET_FUND_CITATIONS", await axios.get(`/api/fundcitations/order/${orderId}`))
    },
    async getFundCitation({ commit, state}, id) {
        commit("SET_FUND_CITATION", await axios.get(`/api/fundcitations/${id}`))
    },
    async saveFundCitation({ commit, state }, orderId) {
        state.fundCitation.orderId = orderId;
        commit("CLEAR_ERRORS");
        return await axios.post('/api/fundcitations', state.fundCitation);
    },
    async removeFundCitation({ commit}, id) {
        return await axios.delete(`/api/fundcitations/${id}`)
    },
}
